// Safely render chat messages as HTML for use with dangerouslySetInnerHTML.
//
// Message content comes from two untrusted sources — the user's own typed
// input and the model's response. Both can contain HTML tags that the
// previous implementation injected verbatim. Escape first, then apply the
// supported formatting (newline → <br>, *text* → <em>).

const ESCAPE_MAP = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;'
};

export function escapeHtml(str) {
  if (str === null || str === undefined) return '';
  return String(str).replace(/[&<>"']/g, (ch) => ESCAPE_MAP[ch]);
}

export function formatMessageHtml(content) {
  return escapeHtml(content)
    .replace(/\n/g, '<br>')
    .replace(/\*([^*]+)\*/g, '<em>$1</em>');
}
